var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.name + "__wrap")},[_c('virtual-list',{class:(_vm.name + "__content"),attrs:{"data-testid":"common-tiktok-list-list-gL1yvz","scrollable":"","data-key":"id","keep":40,"extra-props":{
      onClick: _vm.onClick,
      activeData: _vm.activeData,
      onPopoverCTA: _vm.onPopoverCTA,
      onAuthorizeBA: _vm.onAuthorizeBA,
      isSupportBCNvN: _vm.isSupportBCNvN,
    },"bottom-threshold":3,"data-sources":_vm.dataList,"data-component":_vm.ListItem},on:{"tobottom":_vm.onScrollBottom}}),_vm._v(" "),(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],class:(_vm.name + "__list-loading")}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }